import script from "./UtteranceList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UtteranceList.vue?vue&type=script&lang=ts&setup=true"

import "./UtteranceList.vue?vue&type=style&index=0&id=42e71ea0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e71ea0"]])

export default __exports__